/**
 * Port von `IwmSharedColumnsDeadline.razor`. Die Klasse `container` stammt aus dem
 * Altclient und bleibt erhalten; `iwm-deadline-cell` grenzt die Regeln gegen Bootstrap
 * ab (REQ-05 §4).
 */

import { cx } from '@/components/ui/classNames';
import { formatDate } from '@/utils/date';

import { getDeadlineStyle } from '../rowColors';

export interface DeadlineCellProps {
  deadline: string | null;
  final: string | null;
}

export function DeadlineCell(props: DeadlineCellProps) {
  const style = getDeadlineStyle(props.deadline, props.final);
  return (
    <div className={cx('iwm-deadline-cell', 'container', style)}>
      {props.final === null ? '' : formatDate(props.final)}
    </div>
  );
}

export default DeadlineCell;
